module.exports = __webpack_public_path__ + "static/media/Bitter-Regular.5fff7960.ttf";